module.exports = __webpack_public_path__ + "img/info.f0cb5785.svg";